module.exports = {
      id: "pause-usage",
      viewBox: "0 0 31 30",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#pause",
      toString: function () {
        return this.url;
      }
    }